angular.module('bmsApp.settings').controller('EnquiryGdprCleansingIndexCtrl', function($q,
    $state,
    $scope,
    $cookies,
    ngTableParams,
    // ngTableEventsChannel,
    $ngBootbox,
    notify,
    EmailSvc,
    EnquirySvc,
    EnquiryStatusSvc,
    InstanceSvc,
    $localStorage) {


    // $scope.loading = true;
    $scope.updating = true;
    $scope.ecomEnabled = InstanceSvc.instance.ecomEnabled();
    $scope.selectedIds = [];

    var defaultEnquiryParams = function() {
        return {
            page: 1, // show first page
            count: $scope.config.table.params.count, // count per page
            sorting: {
                id: 'asc' // initial sorting
            },
            filter: {
                search: '',
                ready_for_cleansing: 1,
                deleted: false,
            }
        }
    };

    var initialEnquiryParams = function() {
        if (angular.isDefined($localStorage.enquiryCleansingIndexParams)) {
            return angular.extend({}, defaultEnquiryParams(), $localStorage.enquiryCleansingIndexParams);
        } else {
            return angular.extend({}, defaultEnquiryParams());
        }
    };

    var params = initialEnquiryParams();

    // copy the filters to a workable state
    $scope.enquiryFilters = angular.copy(params.filter);

    $scope.tableParams = new ngTableParams(params, {
        total: 0, // length of data
        counts: $scope.config.table.settings.counts, // available page counts
        getData: function($defer, params) {
            $scope.loading = true;
            $localStorage.enquiryCleansingIndexParams = params.$params;
            EnquirySvc.index(params.$params)
                .then(function(response) {
                    params.total(response.data.enquiry_filtered_count);
                    $defer.resolve(response.data.enquiry_collection);
                    $scope.$emit('enquiryIndexUpdated', {
                        enquiry_collection: response.data.enquiry_collection,
                        enquiry_filtered_count: response.data.enquiry_filtered_count,
                        enquiry_total_count: response.data.enquiry_total_count
                    });

                    $scope.enquiry_filtered_count = response.data.enquiry_filtered_count;
                    $scope.enquiry_total_count = response.data.enquiry_total_count;

                    // Check if we've exceeded our page size, if we have, go back
                    if (response.data.enquiry_filtered_count > 0 && !response.data.enquiry_collection.length) {
                        let newParams = angular.copy($scope.tableParams.$params);
                        newParams.page--;
                        angular.extend($scope.tableParams.$params, newParams);
                    }
                    $scope.loading = false;
                });
        }
    });


    // Store the table params whenever anything changes
    $scope.$watch('tableParams.$params', function(value) {
        if (angular.isObject(value)) {
            $cookies.enquiryCleansingIndexParams = JSON.stringify(value);
        }
    }, true);

    $scope.rowClicked = function(enquiry) {
        enquiry.selected_for_cleansing = !enquiry.selected_for_cleansing;
    };

    // text search
    $scope.filterChanged = function() {
        $scope.tableParams.$params.filter.search = $scope.enquiryFilters.search;
    };

    $scope.all_selected = false;
    $scope.all_select_deselect_toggle_btn_label = 'Select All';
    
    $scope.selectOrDeselectAll = function() {
        angular.forEach($scope.tableParams.data, function(enquiry, key) {

            if (!$scope.all_selected) {
                enquiry.selected_for_cleansing = true;
            } else {
                enquiry.selected_for_cleansing = false;
            }
        })
        $scope.all_selected = !$scope.all_selected;
        $scope.all_select_deselect_toggle_btn_label = $scope.all_selected ? 'Deselect All' : 'Select All';
    }

    $scope.toggleSelection = function() {
        angular.forEach($scope.tableParams.data, function(enquiry, key) {
            enquiry.selected_for_cleansing = !enquiry.selected_for_cleansing;
        })
    }

    $scope.cleanseSelected = function() {
        if (!$scope.oneOrMoreEnquiriesSelected()) {
            return;
        }

        $ngBootbox.confirm('Are you sure you want to cleanse the selected enquiries?')
            .then(function () {

                $scope.loading = true;

                EnquirySvc.gdprCleansing({
                        'selected_ids': $scope.selectedIds,
                    })
                    .then(function(response) {
                        $scope.loading = false;
                        notify({
                            message: 'Selected enquiries cleansed successfully'
                        });
                        $scope.selectedIds = [];
                        $scope.tableParams.reload();
                        $scope.all_selected = false;
                        $scope.all_select_deselect_toggle_btn_label = 'Select All';
                    }, function (error) {
                        //Need to check with this
                        notify({
                            message: 'Something went wrong',
                            classes: 'error'
                        });
                        $log.error(error);
                    });
            });

    };

    $scope.keepSelected = function() {
        if (!$scope.oneOrMoreEnquiriesSelected()) {
            return;
        }

        $ngBootbox.confirm('Are you sure you want to postpone the cleansing of these selected enquires?')
            .then(function () {
                $scope.loading = true;
                EnquirySvc.postponeGdprCleansing({
                        'selected_ids': $scope.selectedIds,
                    })
                    .then(function(response) {
                        $scope.loading = false;
                        notify({
                            message: 'Selected enquiries kept for a further 12 months'
                        });
                        $scope.selectedIds = [];
                        $scope.tableParams.reload();
                        $scope.all_selected = false;
                        $scope.all_select_deselect_toggle_btn_label = 'Select All';
                    });
            });

    };

    $scope.oneOrMoreEnquiriesSelected = function() {
        $scope.selectedIds = [];
        angular.forEach($scope.tableParams.data, function(enquiry, key) {
            if (enquiry.selected_for_cleansing == true) {
                $scope.selectedIds.push(enquiry.id);
            };
        })

        if ($scope.selectedIds.length == 0) {
            notify({
                message: 'Please select one or more enquiries',
                classes: 'error',
            });
            return false;
        }
        return true;

    }

});
